<template lang="pug">
  .b-switch(:class="{ checked: value }" @click="$emit('change', !value)")
</template>

<script>
export default {
  name: 'BaseSwitch',
  model: { event: 'change' },
  props: {
    value: Boolean,
  },
};
</script>

<style scoped lang="scss">
.switch {
  display: inline-block;
  width: 40px;
  height: 20px;
  border-radius: 11.5px;
  background: #D1D9F0;
  transition: background .25s;
  position: relative;
  cursor: pointer;

  &:before {
    display: block;
    content: '';
    width: 18px;
    height: 18px;
    border-radius: 100%;
    background: #fff;
    transition: left .25s;
    position: absolute;
    top: 1px;
    left: 1px;
  }

  &.checked {
    background: #33A1FB;

    &:before {
      left: 21px;
    }
  }
}
</style>
